<template>
  <div class="main">
    <div :class="{ header: true, header2: webType == 2 }">
      <img
        v-if="webType == 1"
        class="cw-logo"
        src="../assets/cw-logo.png"
        alt=""
      />
      <div v-if="webType == 1">少儿美育课堂管理端</div>
      <!-- <div v-if="webType == 2">课本里的奥秘课程管理端</div> -->
      <img
        v-if="webType == 2"
        class="kbldam-title"
        src="../assets/kbldam.png"
        alt=""
      />
      <div :class="{ 'login-info': true, 'login-info2': webType == 2 }">
        <div
          v-if="webType == 1"
          class="bwh"
          @click="
            () => {
              this.showBWH = true
            }
          "
        >
          编辑委员会
        </div>
        <div v-if="webType == 1" class="bwh-line"></div>
        <div class="login-name">
          <el-dropdown @command="handleTopMenuClick" trigger="click">
            <span class="el-dropdown-link">
              Hi,{{ user.nick_name
              }}<i
                v-if="user.role == 'school' || user.role == 'teacher'"
                class="el-icon-arrow-down el-icon--right"
              ></i>
            </span>
            <el-dropdown-menu
              v-if="user.role == 'school' || user.role == 'teacher'"
              slot="dropdown"
            >
              <el-dropdown-item
                v-if="user.role == 'school'"
                command="importStuNo"
                >导入学号</el-dropdown-item
              >
              <el-dropdown-item command="feedback">意见反馈</el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
        </div>

        <span class="logout" @click="logout">退出</span>
      </div>
    </div>
    <div v-if="showBWH" class="bwh-content">
      <div
        class="bwh-close"
        @click="
          () => {
            this.showBWH = false
          }
        "
      >
        <img class="bwh-close-icon" src="../assets/cw-bwh-close.png" alt="" />
      </div>
      <img class="bwh-img" src="../assets/cw-bwh.png" alt="" />
    </div>
    <div class="body">
      <aside class="menu">
        <el-menu
          :default-active="activeIndex"
          class="el-menu-vertical-demo"
          @select="menuSelect"
        >
          <el-menu-item
            index="0"
            v-if="user.role !== 'teacher' && webType == 1"
          >
            <span class="menu-text" slot="title">用户管理</span>
          </el-menu-item>
          <el-submenu index="1" v-if="!user.role">
            <template slot="title">
              <span class="menu-text">课程管理</span>
            </template>
            <el-menu-item-group>
              <el-menu-item index="1">课程列表</el-menu-item>
              <el-menu-item index="2" v-if="webType == 1"
                >内容配置</el-menu-item
              >
            </el-menu-item-group>
          </el-submenu>
          <el-menu-item index="3" v-if="user.role !== 'teacher'">
            <span class="menu-text" slot="title">班级管理</span>
          </el-menu-item>
          <el-menu-item index="4" v-if="user.role == 'school'">
            <span class="menu-text" slot="title">在线教学</span>
          </el-menu-item>
          <el-menu-item index="5" v-if="user.role !== 'teacher'">
            <span class="menu-text" slot="title">账号管理</span>
          </el-menu-item>
          <el-submenu index="6" v-if="user.role == 'teacher'">
            <template slot="title">
              <span class="menu-text">在线教学</span>
            </template>
            <el-menu-item-group>
              <el-menu-item index="6">上课</el-menu-item>
              <el-menu-item index="7" v-if="webType == 1">班级</el-menu-item>
            </el-menu-item-group>
          </el-submenu>
          <el-menu-item index="8" v-if="!user.role && webType == 1">
            <span class="menu-text" slot="title">收到反馈</span>
          </el-menu-item>
        </el-menu>
      </aside>
      <div class="container">
        <div class="container-box">
          <router-view />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { webType } from '../const'
export default {
  name: 'Main',
  data: () => {
    return {
      activeIndex: '0',
      user: { nick_name: '', role: 'none' },
      webType,
      showBWH: false,
    }
  },
  mounted() {
    if (webType == 2) {
      document.title = '课本里的奥秘课程管理端'
    } else {
      document.title = '少儿美育课堂管理端'
    }
    let path = this.$route.path
    let user = JSON.parse(localStorage.getItem('mykc-user'))
    if (!user) {
      this.$router.push('/login')
      return
    }
    this.user = user
    if (path == '/') {
      if (webType == 2) {
        this.$router.push('/courseList')
      } else {
        this.$router.push('/userManage')
      }
    }
    console.log('path', path)
    let indexDic = {
      '/userManage': '0',
      '/courseList': '1',
      '/contentConfig': '2',
      '/classManage': '3',
      '/teachAdmin': '4',
      '/accountManage': '5',
      '/teach': '6',
      '/class': '7',
    }
    this.activeIndex = indexDic[path]
  },
  methods: {
    menuSelect(e) {
      let routesArr = [
        '/userManage',
        '/courseList',
        '/contentConfig',
        '/classManage',
        '/teachAdmin',
        '/accountManage',
        '/teach',
        '/class',
        '/feedbackList',
      ]
      this.$router.push(routesArr[e])
    },
    logout() {
      this.$confirm('确认退出登录吗', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      }).then(() => {
        this.$message({
          type: 'success',
          message: '已退出登录!',
        })
        localStorage.removeItem('mykc-user')
        localStorage.removeItem('mykc-token')
        this.$router.push('/login')
      })
    },
    handleTopMenuClick(command) {
      console.log('click', command)
      if (command == 'feedback') {
        this.$router.push('/feedback')
      } else if (command == 'importStuNo') {
        this.$router.push('/exportStudent')
      }
    },
  },
}
</script>

<style lang="less">
.main {
  width: 100vw;
  height: 100vh;
  .menu-text {
    font-weight: 600;
    font-size: 16px;
  }
  .header {
    display: flex;
    align-items: center;
    position: relative;
    height: 70px;
    padding-left: 50px;
    line-height: 70px;
    font-size: 24px;
    font-weight: bold;
    color: #fff;
    text-align: left;
    background-image: url('../assets/headerBg.png');
    background-repeat: no-repeat;
  }
  .header2 {
    background-image: url('../assets/headerBg2.png');
    .kbldam-title {
      width: 285px;
      height: 25px;
    }
  }
  .cw-logo {
    width: 137px;
    height: 27px;
    margin-right: 26px;
  }
  .bwh {
    font-weight: 500;
    font-size: 14px;
    color: #ffffff;
    line-height: 44px;
    cursor: pointer;
  }
  .bwh-line {
    width: 1px;
    height: 13px;
    margin: 0 24px;
    background-color: #fff;
  }
  .bwh-content {
    position: fixed;
    right: 0;
    bottom: 0;
    width: 440px;
    height: calc(100vh - 70px);
    padding: 40px 0 40px 20px;
    background: #ffffff;
    box-shadow: 10px 0px 50px 0px rgba(0, 0, 0, 0.16);
    box-sizing: border-box;
    overflow: auto;
    z-index: 999;
    .bwh-close {
      display: flex;
      align-items: center;
      justify-content: center;
      position: fixed;
      top: 70px;
      right: 10px;
      width: 60px;
      height: 60px;
      .bwh-close-icon {
        width: 14px;
        height: 14px;
      }
    }
    .bwh-img {
      width: 380px;
    }
  }

  .login-info {
    display: flex;
    align-items: center;
    position: absolute;
    right: 30px;
    top: 0;
    display: flex;
    height: 70px;
    line-height: 70px;
    font-size: 16px;

    .login-name {
      height: 70px;
      margin-right: 10px;
      cursor: pointer;
      .el-dropdown {
        color: #fff;
        height: 36px;
        line-height: 36px;
      }
    }

    .logout {
      box-sizing: border-box;
      width: 60px;
      height: 30px;
      // margin-top: 20px;
      text-align: center;
      line-height: 30px;
      border-radius: 15px;
      border: 1px solid #fff;
      cursor: pointer;
    }
  }
  .login-info2 {
    color: #302b5b;
    .logout {
      color: #5950b1;
      border: 1px solid #5950b1;
    }
  }

  .qrcode {
    position: absolute;
    top: 0;
    left: -120px;

    .hide-image {
      position: absolute;
      top: 0;
      right: 0;
      bottom: 0;
      left: 0;
      opacity: 0;
    }
  }

  .body {
    display: flex;
  }

  .menu {
    width: 200px;
    height: calc(100vh - 70px);
    overflow: hidden;
    background-color: #fff;
    box-shadow: rgba(29, 35, 41, 0.05) 2px 0px 8px 0px;

    text-align: center;
    .el-menu.el-menu--horizontal {
      border-bottom: none;
    }

    .el-menu-item {
      width: 100%;
      padding-left: 5px;
      color: #333;
      &:hover {
        background-color: #ecf5ff;
      }
    }

    .is-active {
      color: #409eff;
    }

    .el-menu--horizontal .el-menu-item:not(.is-disabled):focus,
    .el-menu--horizontal .el-menu-item:not(.is-disabled):hover {
      outline: 0;
      color: #409eff;
    }
  }

  .container {
    box-sizing: border-box;
    width: calc(100% - 200px);
    height: calc(100vh - 70px);
    padding: 10px;
    background-color: rgb(240, 242, 245);
    overflow-y: auto;

    .container-box {
      box-sizing: border-box;
      width: 100%;
      height: 100%;
      padding: 10px;
      background-color: #fff;
      overflow-y: auto;
    }
  }

  // 搜索公共样式
  .line {
    display: flex;
    padding: 20px;
  }

  .search-input {
    width: 180px;
    margin-right: 10px;
  }

  .search-select {
    width: 120px;
    margin-right: 10px;
  }

  .data-table {
    box-sizing: border-box;
    width: 100%;
    // height: calc(100vh - 240px);
    padding: 0 20px;
    margin-bottom: 10px;
  }

  .search-button {
    margin-right: 10px;
  }
}
</style>
